import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "./Redux/action";
import { toast, ToastContainer } from "react-toastify";
import { Cookies, useCookies } from "react-cookie";

import Config from "./config/config";
import {
  getCookie,
  isEmpty,
  NumberChange,
  SetToken,
} from "./Actions/commonFunction";
import { getAnswer, getQuestion, Signon } from "./Actions/v1/user";
import { setAccount, setAnserDetails, setAnswer, setQuestion } from "./Redux/user.action";
import Vac from "./Pages/Vac";
import Vacverification from "./Pages/Vacverification";
import Vacscorecard from "./Pages/vacscorecard";
import Vacsystem from "./Pages/Vacsystem";
import Vacreqform from "./Pages/Vacreqform";
import Vacnewcoin from "./Pages/Vacnewcoin";
import Vacexchange from "./Pages/Vacnewexchange"
import RequestList from "./Pages/Requestlist";
import Vacfinal from "./Pages/Vacfinal";
import Scorecardanalysis from "./Pages/Scorecardanalysis";
import Listexchange from "./Pages/Exchange/Listexchange";
import Scorecardexchange from "./Pages/Exchange/Scorecardexchange";
import Listcointoken from "./Pages/Cointoken/Listcointoken";
import Scorecardcointoken from "./Pages/Cointoken/Scorecardcointoken";

import Viewformdetails from "./Pages/Formviewdetails";

function App() {
  const cookies = new Cookies();
  const theme = useSelector((state) => state.theme.theme);
  const dispatch = useDispatch();

  async function checkCookie(cookieName) {
    let cookie = getCookie(cookieName);
    console.log("cookiecookie", cookie);
    if (cookie != "") {
      let getusercookie = getCookie(Config.userCookieName);
      if (isEmpty(localStorage.registedEmail) || isEmpty(getusercookie)) {
        let Resp = await Signon({ data: cookie });
        console.log("RespResp1", Resp?.data);
        // Resp.data = {...Resp.data.data,token : Resp.token}
        // console.log("🚀 ~ checkCookie ~ Resp.data:", Resp.data)
        if (Resp?.status) {
          cookies.removeChangeListener(cookieChangeListener);
          toast.success("Login Successfully");
          localStorage.setItem("registedEmail", Resp?.data?.data.EmailId);
          SetToken(Config.userCookieName, Resp?.data.token);
          let answer = await getAnswer({
            userId: Resp.data?.data._id,
          });
          let question = await getQuestion();
          if(question?.status){
            dispatch(setQuestion(question?.data));
          }
          console.log("🚀 ~ checkCookie ~ answer:", answer)
          dispatch(setAnswer({
            answer : answer?.data?.[0]?.answer,
            totalscore : answer?.data?.[0]?.totalscore,
            status : answer?.data?.[0]?.status,
            assetname : answer?.data?.[0]?.assetname,
            address : answer?.data?.[0]?.address,
          }))
          dispatch(setAnserDetails(answer?.data[0]));
          dispatch(
            setAccount({
              Regname: Resp.data?.data.Regname,
              Profile: Resp.data?.data.Profile,
              Customurl: Resp.data?.data.Customurl,
              _id: Resp.data?.data._id,
              EmailId : Resp?.data?.data?.EmailId
            })
          );
        }
      } 
    } else {
      if (!isEmpty(localStorage.registedEmail)) {
        localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      console.log("cookie doesnot exist set the cookie again");
    }
  }

  const cookieChangeListener = () => {
    checkCookie(Config.cookiename);
  };

  //Console off for Production
  useEffect(() => {
    if (Config.EnvName == "production") {
      console.log = () => {};
      console.warning = () => {};
      console.info = () => {};
      console.error = () => {};
    }
  }, []);

  useEffect(() => {
    let currTheme = localStorage.getItem("theme");
    console.log("currThemecurrTheme", currTheme);
    dispatch(setTheme(currTheme ? currTheme : "light"));
  }, []);

  useEffect(() => {
    cookies.addChangeListener(cookieChangeListener);
    let cookie = getCookie(Config.cookiename);
    let getusercookie = getCookie(Config.userCookieName);
    console.log("getusercookie", getusercookie);
    if (
      (isEmpty(localStorage.registedEmail) || isEmpty(getusercookie)) &&
      !isEmpty(cookie)
    ) {
      cookieChangeListener();
    }
  }, []);

  useEffect(() => {
    checkCookie();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Vac />} />
          <Route path="/vac-verification" element={<Vacverification />} />
          <Route path="/vac-scorecard" element={<Vacscorecard />} />
          <Route path="/scorecardanalysis" element={<Scorecardanalysis />} />
          <Route path="/vac-system" element={<Vacsystem />} />
          <Route path="/vac-score-system" element={<Vacfinal />} />
          <Route path="/vac-reqform" element={<Vacreqform />} />
          <Route path="/vacnewcoin" element={<Vacnewcoin/>} />
          <Route path="/vacnewexchange" element={<Vacexchange/>} />
          <Route path="/myrequest" element={<RequestList/>} />
          <Route path="/editrequest" element={<Vacnewcoin/>} />
          <Route path="/editexchange" element={<Vacexchange/>} />

          <Route path="/listexchange" element={<Listexchange/>} />  
          <Route path="/scorecardexchange" element={<Scorecardexchange/>} />  

          <Route path="/listcointoken" element={<Listcointoken/>} />  
          <Route path="/scorecardcointoken" element={<Scorecardcointoken/>} /> 
          <Route path="/viewformdetails" element={<Viewformdetails/>} />            

        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            className: "fw-600",
            style: {
              textAlign: "center",
              background: "rgb(58 183 27)",
              color: "white",
            },
          },
          error: {
            className: "fw-600",
            style: {
              textAlign: "center",
              background: "#cd1212",
              color: "white",
            },
          },
        }}
      />
    </>
  );
}

export default App;
